/* global axios */

import ApiClient from './ApiClient';

class ExternalDatabaseConnectionsApi extends ApiClient {
  constructor() {
    super('database_connections', { accountScoped: true });
  }

  // Lista todas as tabelas
  listTables() {
    return axios.get(`${this.url}/tables`);
  }

  describeTable(tableName, options = {}) {
    const {
      filterPhoneColumns = false,
      filterNameColumns = false
    } = options;

    return axios.post(`${this.url}/tables/${tableName}/describe`, {
      filter_phone_columns: filterPhoneColumns,
      filter_name_columns: filterNameColumns
    });
  }



// Método unificado para consultar tabela (substitui showTable, selectTableWithFilters e fetchTableWithLimitAndCount)
  queryTable(tableName, options = {}) {
    const {
      filters = [],
      columns = ['*'],
      maxRecords = 1000,
      includeCount = true,
      // Suporte legacy para paginação
      page = null,
      perPage = null,
    } = options;

    const payload = {
      filters,
      columns,
      max_records: maxRecords,
      include_count: includeCount,
    };


    // Adicionar paginação legacy se fornecida
    if (page !== null && perPage !== null) {
      payload.page = page;
      payload.per_page = perPage;
    }

    return axios.post(`${this.url}/tables/${tableName}/query`, payload);
  }

  // Métodos de conveniência para manter compatibilidade
  showTable(tableName) {
    return this.queryTable(tableName, {
      filters: [],
      maxRecords: 100,
      includeCount: false,
    });
  }

  selectTableWithFilters(tableName, filters, columns = ['*'], page = 1, perPage = 500) {
    return this.queryTable(tableName, {
      filters,
      columns,
      page,
      perPage,
      includeCount: false,
    });
  }

  // Sem `refresh`, devolve o que está gravado no canal (a sondagem diária de
  // saúde mantém o tier fresco). `refresh: true` força a leitura na Meta.
  fetchWhatsappMessageLimit(inboxId, { refresh = false } = {}) {
    return axios.get(`${this.url}/whatsapp_message_limit`, {
      params: { inbox_id: inboxId, refresh: refresh || undefined },
    });
  }
}

export default new ExternalDatabaseConnectionsApi();
